export default "__VITE_ASSET__0xYiVyyo__"